// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'chat-quote';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.313 14.063H8.438l-4.5 3.374v-3.375h-2.25a1.125 1.125 0 0 1-1.125-1.124V1.688A1.125 1.125 0 0 1 1.688.563h14.624a1.125 1.125 0 0 1 1.125 1.125v11.25a1.125 1.125 0 0 1-1.125 1.124z' />
    <path d='M11.25 6.188a.57.57 0 0 0-.563-.563' />
    <path d='M10.688 6.75a.57.57 0 0 0 .562-.563m-1.125.001a.57.57 0 0 0 .563.562m0-1.125a.57.57 0 0 0-.563.563' />
    <path d='M10.808 9.195A2.093 2.093 0 0 0 12 7.41c0-.75-.375-1.687-1.252-1.777m-3.435.555a.57.57 0 0 0-.563-.563' />
    <path d='M6.75 6.75a.57.57 0 0 0 .563-.563m-1.125.001a.57.57 0 0 0 .562.562m0-1.125a.57.57 0 0 0-.563.563' />
    <path d='M6.87 9.195A2.093 2.093 0 0 0 8.085 7.41c0-.75-.375-1.687-1.252-1.777' />
  </g>
);

export const viewBox = '0 0 18 18';
